import type { FinancingDraft } from '@/components/financing-requests/financingDraft'
import type { AdditionalPurchaseCostKey } from '@/utils/investment'
import { watch } from 'vue'

export interface PurchaseCostDefaults {
  broker_commission: number
  notary_land_registry_fees: number
}

/**
 * The Kaufnebenkosten start from the usual rates, the Grunderwerbssteuer from the chosen state.
 * A rate the investor typed over survives — only an untouched suggestion follows the state.
 */
export function useDefaultPurchaseCosts(
  draft: FinancingDraft,
  landRegisterCharge: () => number | null,
  defaults: PurchaseCostDefaults,
): void {
  const suggested: Partial<Record<AdditionalPurchaseCostKey, number>> = {}

  const suggest = (key: AdditionalPurchaseCostKey, rate: number | null): void => {
    const untouched = draft[key] === null || draft[key] === suggested[key]

    if (rate === null || !untouched) {
      return
    }

    draft[key] = rate
    draft[`${key}_unit`] = 'percent'
    suggested[key] = rate
  }

  watch(
    landRegisterCharge,
    (rate) => {
      suggest('land_register_charge', rate)
      suggest('broker_commission', defaults.broker_commission)
      suggest('notary_land_registry_fees', defaults.notary_land_registry_fees)
    },
    { immediate: true },
  )
}
